import { clsx } from 'clsx';
import { useNavigate } from 'react-router-dom';
import { SETTINGS_DOORS, type SettingsDoorKey } from './doors';

/**
 * The second 200px column behind every Settings door — `.subrail`, §13.2's
 * answer for a door set too long for one tab row. The board's own closing line
 * on `g_set` says what it is for: "Behind every one of them this grid stands
 * folded into a single column on the left, so nothing in Settings is ever more
 * than one click from anything else in it."
 *
 * WHY NOT THE KIT'S `SubRail`. The kit's takes `head?: string`, and the board's
 * head is a CONTROL — "‹ System Settings", brand-coloured, which walks back to
 * the grid. A string cannot carry that, and widening the kit for one role is
 * how a kit stops being one (BRIEF §3). Same markup, same classes; only the
 * head differs.
 */
export function SettingsRail({ active }: { active: SettingsDoorKey }) {
  const go = useNavigate();

  return (
    <nav className="subrail" aria-label="System Settings">
      <p className="sr-head">
        {/* `textTransform` is not decoration. `.sr-head` is
            `text-transform: uppercase`, and the global button reset
            (`button { text-transform: none }`) beats the INHERITED value on
            this one element — so the head printed "‹ System Settings" where
            every Settings artboard prints "‹ SYSTEM SETTINGS". `font` and
            `letterSpacing` are re-asserted from the same reset, and this is
            the third of the three. */}
        <button
          type="button"
          className="w6"
          style={{ cursor: 'pointer', color: 'var(--brand-600)', background: 'none', border: 0, padding: 0, fontFamily: 'inherit', fontSize: 'inherit', lineHeight: 'inherit', letterSpacing: 'inherit', textTransform: 'uppercase' }}
          onClick={() => go('/clinic-manager/settings')}
        >
          ‹ System Settings
        </button>
      </p>
      {SETTINGS_DOORS.map((d) => {
        const on = d.key === active;
        return (
          <button
            key={d.key}
            type="button"
            aria-current={on ? 'page' : undefined}
            className={clsx('sr-item', on && 'on')}
            disabled={on}
            onClick={on ? undefined : () => go(d.to, d.key === 'directory' ? { state: { settingsFrame: true } } : undefined)}
          >
            <span className="grow">{d.title}</span>
          </button>
        );
      })}
    </nav>
  );
}
